// combat-alert-radius.ts — the one client copy of the combat-start hearing range.
//
// Mirrors FT_COMBAT_HEARING_RANGE_FT (includes/functions/janus/encounter/combat_membership.php): an
// opposing creature within this many feet (centre to centre, same floor, halved through a closed
// door) hears the fight and joins it. Sight has no fixed radius — it follows light and senses.
// Shared by the island resolver (roll-init) and the FT3D alert ring the initiative picker paints, so
// the ring can never describe a different range than the one that decides who joins.
export const COMBAT_ALERT_HEARING_RADIUS_FT = 30;
